import {
  Component,
  Input,
  AfterViewInit,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef
} from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';

@Component({
  selector: 'app-datatable-pager',
  template: `<ul class="pager">
  <li class="page-size-continer" (click)="pageSizeColumn=!pageSizeColumn" (mouseleave)="pageSizeColumn=true">
    <span>{{size}} 行/页</span>
    <ul [hidden]="pageSizeColumn" class="page-size-content">
      <li *ngFor="let ps of pageSizeArray" (click)="changePageSize(ps)" [ngClass]="{'page-size-column-active':size===ps}">{{ps}} 行/页</li>
    </ul>
  </li>
  <li [class.disabled]="!canPrevious()">
    <a (click)="selectPage(1)">
      <i class="{{pagerPreviousIcon}}"></i>
    </a>
  </li>
  <li [class.disabled]="!canPrevious()">
    <a (click)="prevPage()">
      <i class="{{pagerLeftArrowIcon}}"></i>
    </a>
  </li>
  <li class="pages" *ngFor="let pg of pages" [class.active]="pg.number === page">
    <a (click)="selectPage(pg.number)">
      {{pg.text}}
    </a>
  </li>
  <li [class.disabled]="!canNext()">
    <a (click)="nextPage()">
      <i class="{{pagerRightArrowIcon}}"></i>
    </a>
  </li>
  <li [class.disabled]="!canNext()">
    <a (click)="selectPage(totalPages)">
      <i class="{{pagerNextIcon}}"></i>
    </a>
  </li>
  <li [ngStyle]="{'position':'relative'}">
  <span>跳转到</span>
  <input #customerInput class="lz-jump-page" type="number" rows="2" [min]="1" [ngModel]="page" onkeydown='if(event.keyCode==13) return false;'
    onblur="return false" (ngModelChange)="customerInput.value=$event===0?1:$event>totalPages?totalPages:$event" /> 页
  </li>
</ul>
`,
  styles: [
    `
      .page-size-continer {
        position: relative;
        width: 80px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        border: solid 1px #eae9e9;
        border-radius: 2px;
        cursor: pointer;
      }
      .page-size-continer:hover {
        background-color: rgba(158, 158, 158, 0.2);
      }
      .page-size-continer .page-size-content {
        position: absolute;
        bottom: 24px;
        left: 0;
        padding: 0;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 0 15px 1px rgba(113, 106, 202, 0.2);
        z-index: 11;
      }
      .page-size-continer .page-size-content li {
        width: 100%;
        padding: 4px 0;
      }
      .page-size-continer .page-size-content li:hover {
        background-color: rgba(158, 158, 158, 0.2);
      }
      .page-size-continer .page-size-content .page-size-column-active {
        color: #409eff;
      }
      input[type='number']::-webkit-inner-spin-button,
      input[type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none;
      }
      .lz-jump-page {
        display: inline-block;
        width: 50px;
        border-radius: 2px;
        margin-right: 6px;
        padding-left: 4px;
        border: solid 1px #ebedf2;
      }
      input[type='number'] {
        -moz-appearance: textfield;
      }
    `
  ]
})
export class DatatablePagerComponent implements AfterViewInit {
  @Input() pagerLeftArrowIcon?: string = 'fa fa-angle-left';
  @Input() pagerRightArrowIcon?: string = 'fa fa-angle-right';
  @Input() pagerPreviousIcon?: string = 'fa fa-step-backward';
  @Input() pagerNextIcon?: string = 'fa fa-step-forward';
  @Input() pageSizeArray?: any[];
  @Input() datatable: any;

  @Input()
  set size(val: number) {
    this._size = val;
    this.pages = this.calcPages();
  }
  get size(): number {
    return this._size;
  }

  @Input()
  set count(val: number) {
    this._count = val;
    this.pages = this.calcPages();
  }
  get count(): number {
    return this._count;
  }

  @Input()
  set page(val: number) {
    this._page = val;
    this.pages = this.calcPages();
  }
  get page(): number {
    return this._page || 1;
  }
  get totalPages(): number {
    const count = this.size < 1 ? 1 : Math.ceil(this.count / this.size);
    return Math.max(count || 0, 1);
  }

  @Output() change: EventEmitter<any> = new EventEmitter();

  @ViewChild('customerInput') customerInput: ElementRef;

  ngAfterViewInit() {
    this.asynGetData();
  }

  // tslint:disable-next-line:member-ordering
  _page = 1;
  // tslint:disable-next-line:member-ordering
  _count = 0;
  // tslint:disable-next-line:member-ordering
  _size = 0;
  // tslint:disable-next-line:member-ordering
  pages: any;
  // tslint:disable-next-line:member-ordering
  pageSizeColumn: boolean = true;

  canPrevious(): boolean {
    return this.page > 1;
  }

  canNext(): boolean {
    return this.page < this.totalPages;
  }

  prevPage(): void {
    this.selectPage(this.page - 1);
  }

  nextPage(): void {
    this.selectPage(this.page + 1);
  }

  selectPage(page: number, changePageSize?: any): void {
    if (changePageSize) {
      if (page > 0 && page <= this.totalPages) {
        this.page = page;
        this.change.emit({
          page
        });
      }
    } else {
      if (page > 0 && page <= this.totalPages && page !== this.page) {
        this.page = page;
        this.change.emit({
          page
        });
      }
    }
  }

  calcPages(page?: number): any[] {
    const pages = [];
    let startPage = 1;
    let endPage = this.totalPages;
    const maxSize = 5;
    const isMaxSized = maxSize < this.totalPages;

    page = page || this.page;

    if (isMaxSized) {
      startPage = (Math.ceil(page / maxSize) - 1) * maxSize + 1;
      endPage = Math.min(startPage + maxSize - 1, this.totalPages);
    }

    for (let num = startPage; num <= endPage; num++) {
      pages.push({
        number: num,
        text: num
      });
    }

    return pages;
  }

  changePageSize(pageSize: number) {
    this.datatable.limit = pageSize;
    this.selectPage(1, 'changePageSize');
  }

  // asynGetData
  asynGetData() {
    Observable.fromEvent(this.customerInput.nativeElement, 'input')
      .debounceTime(500)
      .subscribe((event: any) => {
        if (event.target.value) {
          this.selectPage(Math.round(Number(event.target.value)));
        }
      });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/datatable-pager/datatable-pager.component.ts